export const formattedPrice = (value, language) => {
  const round = Math.round(value) === value
  const price = Intl.NumberFormat(
    language,
    round ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  ).format(value)

  return `${price} €`
}
